module.exports = __webpack_public_path__ + "img/bottom-left-corner.09fb068c.svg";